import type { Exhibition } from "@/app/lib/generated/graphql-types";

export interface SpecialExhibitionCategories {
    current: Exhibition[];
    future: Exhibition[];
    past: Exhibition[];
}

export function categorizeSpecialExhibitions(
    exhibitions: Exhibition[],
    today: string,
): SpecialExhibitionCategories {
    const current = exhibitions.filter((exhibition) => (
        exhibition.startDate
        && exhibition.endDate
        && exhibition.startDate <= today
        && exhibition.endDate >= today
    ));
    const future = exhibitions.filter((exhibition) => (
        exhibition.startDate && exhibition.startDate > today
    ));
    const past = exhibitions
        .filter((exhibition) => exhibition.endDate && exhibition.endDate < today)
        .sort((left, right) => (left.endDate ?? "").localeCompare(right.endDate ?? ""))
        .slice(0, 12);

    return { current, future, past };
}
